'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DurationSelect = require('../../lib/DurationSelect');

var _DurationSelect2 = _interopRequireDefault(_DurationSelect);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'expirationSelect': 'Default__expirationSelect___E80hx',
  'arrow': 'Default__arrow___1DJV2',
  'expirationLabel': 'Default__expirationLabel___lM6Eb'
};

var DefaultDurationSelect = (0, _mergeThemeHoc2.default)(style)(_DurationSelect2.default);
DefaultDurationSelect.displayName = 'DefaultDurationSelect';
exports.default = DefaultDurationSelect;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/DurationSelect/index.js
// module id = 847
// module chunks = 4 5 8 9 14